<template>
    <div v-if="show" class="bg-neutral-darker text-sm text-white py-xl w-full z-10">
        <div class="container flex items-start text-sm">
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="translation('feedback_bar_text')" />

            <button
                type="button"
                class="mt-xs ml-sm md:ml-auto text-white"
                @click="hide"
            >
                <font-awesome-icon icon="times" />
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show: false,
            };
        },
        created() {
            this.show = this.$cookies.get('hide_feedback_bar') === null;
        },
        methods: {
            hide() {
                this.$cookies.set('hide_feedback_bar', '1');
                this.show = false;
            },
        },
    };
</script>

<style scoped>
    div >>> p {
        @apply .mb-0;
    }

    div >>> a {
        @apply .text-accent-yellow .font-bold;
    }
</style>